import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { GenericLinkModule, IconModule, MediaModule } from '@spartacus/storefront';
import { AtgHomepageImageCarouselComponent } from './atg-homepage-image-carousel/atg-homepage-image-carousel.component';

@NgModule({
  declarations: [AtgHomepageImageCarouselComponent],
  imports: [CommonModule, GenericLinkModule, MediaModule, IconModule],
  providers: [
    provideConfig({
      cmsComponents: {
        RotatingImagesComponent: {
          component: () =>
            import('./atg-homepage-image-carousel/atg-homepage-image-carousel.component').then(
              (c) => c.AtgHomepageImageCarouselComponent
            ),
        },
      },
    } as CmsConfig),
  ],
  exports: [AtgHomepageImageCarouselComponent],
})
export class AtgHomepageImageCarouselModule {}
